import { BetSlipType } from '../../types';
import { useBetSlipStore, getComboOrSystemBets } from '../../useBetSlip';
import { getUniqueMatchIdCount } from '../../util';
import { ActionLocked, LockedKey } from './ActionLocked';

import { BetTypeMap } from '~/constants';

/**
 * 投注类型切换器组件
 * 用于在单注和串关之间切换
 */
export const BetTypeSwitch = (props: { value: BetSlipType; onChange: (value: BetSlipType) => void }) => {
  const isSelected = (betType: BetSlipType) => props.value === betType;

  const [store] = useBetSlipStore();

  const isDisable = (betType: string) => {
    const { odds } = store;
    return (
      (betType === BetSlipType.Combo && getComboOrSystemBets(odds).length < 2) ||
      (betType === BetSlipType.System && getUniqueMatchIdCount(odds) < 3)
    );
  };

  const betTypeFunc = (betType: string) => {
    return t(BetTypeMap[betType.toUpperCase() as keyof typeof BetTypeMap]);
  };

  const options = createMemo(() =>
    store.systemOffered
      ? [BetSlipType.Single, BetSlipType.Combo, BetSlipType.System]
      : [BetSlipType.Single, BetSlipType.Combo]
  );

  return (
    <div onClick={(e) => e.stopPropagation()} class="bg-betslip-header-section-bg flex px-3 py-2">
      <div class="flex h-10 flex-grow bg-betslip-section-tab-bg rounded-lg p-[0.125rem]">
        <For each={options()}>
          {(betType) => (
            <ActionLocked
              lockedKey={betType === BetSlipType.Single ? LockedKey.bet_type_single : LockedKey.bet_type_parlay}
            >
              <OptionItem
                class={cx(
                  'flex-grow h-9 rounded-[6px] transition-all relative cursor-pointer',
                  isSelected(betType)
                    ? 'bg-layer5_5-card caption-m-semibold text-neutral-main1'
                    : 'caption-m-medium text-neutral-main5'
                )}
                value={betType}
                disabled={isDisable(betType)}
                bind={[() => props.value, props.onChange]}
              >
                <span class="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 cursor-pointer">
                  {betTypeFunc(betType)}
                </span>
              </OptionItem>
            </ActionLocked>
          )}
        </For>
      </div>
    </div>
  );
};
